import { Component } from "solid-js";
import { Img } from "../universal/image";

type SectionBubbleProps = {
    name: string;
    url: string;
    children: any;
    imageUrl: string;
}

export const SectionBubble : Component<SectionBubbleProps> = (props) =>
<>
    <div style="text-align: center;">
        <h2>
            {props.name}
        </h2>
        <div class="circle-container smaller scale">
            <a href={props.url}>
                <Img src={props.imageUrl} mode="crop" width={360} height={360} alt={props.name} style="width: 100%; height: auto;" />
            </a>
        </div>
        <p style="margin-top: 20px;">
            <a class="btn btn-chunky-sm btn-chunky-grey" href={props.url} role="button">Learn More &raquo;</a>
        </p>
    </div>
    <div>
        {props.children}
    </div>
</>;